import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none relative overflow-hidden group';
  const variants = {
    primary: 'bg-gradient-to-r from-forest-700 to-forest-600 text-white hover:from-forest-800 hover:to-forest-700 focus:ring-forest-500 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] rounded-full',
    secondary: 'bg-gradient-to-r from-ember-500 to-ember-600 text-white hover:from-ember-600 hover:to-ember-700 focus:ring-ember-500 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] rounded-full',
    outline: 'border-2 border-forest-700 bg-transparent text-forest-800 hover:bg-forest-700 hover:text-white focus:ring-forest-500 rounded-full font-bold',
    ghost: 'bg-transparent text-forest-700 hover:bg-forest-50 rounded-lg font-medium'
  };
  const sizes = {
    sm: 'h-10 px-5 text-sm',
    md: 'h-12 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-136">
      {variant === 'primary' && <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" data-id="element-137"></span>}
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-138" />}
      <span className="relative z-10" data-id="element-139">{children}</span>
    </button>;
}